export default "__VITE_ASSET__DtkXw5Kb__"